import { render, staticRenderFns } from "./LogoBlack.vue?vue&type=template&id=6a564956&"
import script from "./LogoBlack.vue?vue&type=script&lang=js&"
export * from "./LogoBlack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports